import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Panel } from "@/pages/Billing";

const field = "h-11 w-full rounded-xl border border-slate-700 bg-white px-4 text-sm text-slate-100 outline-none transition-colors focus:border-slate-100";

export default function Account() {
  const { user } = useAuth();
  const [f, setF] = useState({ current: "", next: "", confirm: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (f.next.length < 6) return setError("New password must be at least 6 characters");
    if (f.next !== f.confirm) return setError("New passwords don't match");
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/password", { current_password: f.current, new_password: f.next });
      toast.success("Password changed");
      setF({ current: "", next: "", confirm: "" });
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="max-w-2xl space-y-10" data-testid="account-page">
      <div className="rise">
        <h1 className="font-display text-4xl font-semibold tracking-tight text-slate-50 sm:text-5xl">My account</h1>
        <p className="mt-3 text-sm text-slate-400 md:text-base" data-testid="account-identity">{user?.name ? `${user.name} · ` : ""}{user?.email} · <span className="capitalize">{user?.role}</span></p>
      </div>
      <Panel title="Change password" testId="change-password-panel">
        <form onSubmit={submit} className="space-y-4 p-6" data-testid="change-password-form">
          <input data-testid="current-password-input" type="password" className={field} placeholder="Current password" value={f.current} onChange={(e) => setF({ ...f, current: e.target.value })} />
          <input data-testid="new-password-input" type="password" className={field} placeholder="New password" value={f.next} onChange={(e) => setF({ ...f, next: e.target.value })} />
          <input data-testid="confirm-password-input" type="password" className={field} placeholder="Repeat new password" value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} />
          {error && <p data-testid="change-password-error" className="text-sm text-red-300">{error}</p>}
          <button data-testid="change-password-button" disabled={busy}
            className="inline-flex h-11 items-center gap-2 rounded-full bg-[#0071E3] px-7 text-sm font-semibold text-white transition-colors hover:bg-[#0062CC] disabled:opacity-60">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />} Update password
          </button>
        </form>
      </Panel>
    </div>
  );
}
